import {
    AnalyticsRequest,
    Metric,
    GroupBy,
    Sort,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';

export const HyperSpaceBarChart: Widget = {
    type: 'hyperSpaceBarChart',
    id: 'hyper-space-bar-chart',
    name: 'Bar Chart',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        new AnalyticsRequest({
            limit: 6,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicName },
                    INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_ACCOUNT_ID' },
                    PAID: { dimensionName: 'accountIds' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'RDB_DATA_SOURCE' },
                    UNIVERSAL_PROFILE: { dimensionName: 'SN_TYPE' },
                    TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                    SPR_TASK: { dimensionName: 'ASSIGNEE_ID' },
                    COMMUNITY: { dimensionName: 'AUDIENCE_ACTIVITY_TYPE' },
                    SAM: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    AUDIENCE_ACTIVITY: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    OUTBOUND_MESSAGE: {
                        source: ListeningDimensions.account,
                    },
                    CONSUMPTION: {
                        source: ListeningDimensions.activityType,
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Bar Chart',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        includeMetrics: false,
        zeroFill: true,
        baseXYChartOptions: {
            grid: {
                enabled: false,
            },
            xAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
            yAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
        },
    },
};
